import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController, AlertController } from '@ionic/angular';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { NetworkServiceService } from '../../services/network-service.service';
import { MemberService } from '../../services/member.service';

@Component({
  selector: 'app-network-info',
  templateUrl: './network-info.component.html',
  styleUrls: ['./network-info.component.scss'],
})
export class NetworkInfoComponent implements OnInit {
  networkID: number;
  networkName: string;
  profileData: any;
  subscribed: boolean;
  uid: string;
  userNetworks: any;
  networkList: any;

  constructor(
    private router: Router,
    private popoverController: PopoverController,
    private navParams: NavParams,
    private authService: AuthService,
    private networkService: NetworkServiceService,
    private memberService: MemberService,
    private alertController: AlertController) { }

  ngOnInit() {
    // console.table(this.navParams);
    this.networkID = this.navParams.data.networkID;
    // console.log('networkID', this.networkID);
    this.networkName = this.navParams.data.networkName;
    this.uid = localStorage.getItem('myUID');
    // console.log('uid', this.uid);
    this.networkList = [];
    
    this.memberService.getUserNetworks(this.uid).once('value', snapshot => {
      console.log('snapshot', snapshot.val());
      snapshot.forEach(snap => {
        this.networkList.push(snap.val().id);
        console.log('snap', this.networkList);
      });
      // if (snapshot.val().userNetworks !== undefined) {
      
    });
    if (this.networkList.indexOf(this.networkID) === -1) {
      console.log('index of', this.networkList,  this.networkList.indexOf(this.networkID));
      this.memberService.addUserNetwork(this.uid, this.networkID);
    } else {
      console.log('index of else', this.networkList,   this.networkList.indexOf(this.networkID));
      console.log('network already subscribed');
      this.presentAlert();
    }
  }

  logout() {
    this.authService.logoutUser();
    this.authService.logoutJoomlaUser().subscribe((data) => {
    });
    localStorage.setItem('session_id', null);
    localStorage.setItem('user', null);
    this.profileData = null;
    this.router.navigateByUrl('/sign-in');
  }

  async presentAlert() {
    const alert = await this.alertController.create({
      header: 'Alert',
      subHeader: 'Subscription failed',
      message: 'You are already subscribed to this network.',
      buttons: ['OK']
    });

    await alert.present();
  }

}
